<div class="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
    <div class="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 sm:justify-start sm:gap-6">
        <h2 class="text-xl font-semibold text-gray-800 dark:text-white/90">Settings</h2>
        <nav>
            <ol class="flex items-center gap-1.5">
                <li>
                    <a routerLink="/" class="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400" href="/">
                        Home
                        <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-current">
                            <path d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366" stroke="" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                        </svg>
                    </a>
                </li>
                <li class="inline-flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400">
                    <a routerLink="/dashboard/preferences">Preferences</a>
                    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-current">
                        <path d="M6.0765 12.667L10.2432 8.50033L6.0765 4.33366" stroke="" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </li>
                <li class="text-sm text-gray-800 dark:text-white/90">{{ meta?.label }}</li>
            </ol>
        </nav>
    </div>

    <app-button variant="outline" size="sm" className="w-full sm:w-auto whitespace-nowrap" (click)="goBack()">
        Back to Preferences
    </app-button>
</div>

<div class="space-y-6">
    <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
        <div class="flex items-center justify-between border-b border-gray-200 px-6 py-4 dark:border-gray-800">
            <div>
                <h2 class="text-lg font-medium text-brand-500 dark:text-white">
                    Preferences <span class="text-gray-400 font-normal">&gt;</span> {{ meta?.label }}
                </h2>
                <p class="text-xs text-gray-400 mt-0.5">
                    {{ selectedCount }} selected · click a row to toggle ·
                    <span [ngSwitch]="saveStatus">
                        <span *ngSwitchCase="'saving'">Saving…</span>
                        <span *ngSwitchCase="'saved'" class="text-success-600">All changes saved</span>
                        <span *ngSwitchCase="'error'" class="text-error-600">Couldn't save — <button type="button" class="underline" (click)="preferencesService.retrySave()">retry</button></span>
                        <span *ngSwitchDefault>saved automatically</span>
                    </span>
                </p>
            </div>
        </div>

        <!-- Configured category: grouped table -->
        <div *ngIf="groups.length > 0" class="overflow-x-auto">
            <table class="w-full text-sm">
                <thead>
                    <tr class="text-left text-xs font-semibold text-gray-400 uppercase tracking-wide">
                        <th class="px-6 py-3 w-40">Type</th>
                        <th class="px-6 py-3">Activity / Fetish</th>
                        <th class="px-6 py-3">Description</th>
                        <th class="px-6 py-3 w-20 text-right">Select</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let group of groups">
                        <tr *ngFor="let opt of group.options; let first = first"
                            (click)="toggle(opt.activity)"
                            class="cursor-pointer border-t border-gray-100 dark:border-gray-800 transition-colors"
                            [class.bg-brand-50]="isSelected(opt.activity)"
                            [class.dark:bg-brand-500/10]="isSelected(opt.activity)"
                            [class.hover:bg-gray-50]="!isSelected(opt.activity)">
                            <td class="px-6 py-2.5 align-top font-semibold text-gray-700 dark:text-gray-200">
                                {{ first ? group.type : '' }}
                            </td>
                            <td class="px-6 py-2.5 align-top text-gray-700 dark:text-gray-200">{{ opt.activity }}</td>
                            <td class="px-6 py-2.5 align-top text-gray-500 dark:text-gray-400">{{ opt.description }}</td>
                            <td class="px-6 py-2.5 align-top text-right">
                                <span class="inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border transition-colors"
                                    [ngClass]="isSelected(opt.activity)
                                        ? 'border-brand-500 bg-brand-500'
                                        : 'border-gray-300 bg-transparent dark:border-gray-600'">
                                    <svg *ngIf="isSelected(opt.activity)" class="text-white" width="10" height="10" viewBox="0 0 16 16" fill="none">
                                        <path d="M3 8L6.5 11.5L13 4.5" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                </span>
                            </td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>

        <!-- Not configured yet (Identities / Roles / Dynamics — see preferences.service.ts) -->
        <div *ngIf="groups.length === 0" class="flex flex-col items-center justify-center gap-2 px-6 py-16 text-center">
            <p class="text-sm font-medium text-gray-600 dark:text-gray-300">Options for "{{ meta?.label }}" aren't configured yet</p>
            <p class="max-w-sm text-xs text-gray-400">
                This list comes from a spreadsheet that isn't shared publicly yet, so it couldn't be loaded automatically.
                Share it as "Anyone with the link can view" and this panel can be filled in.
            </p>
        </div>

        <div class="flex justify-end border-t border-gray-200 px-6 py-5 dark:border-gray-800">
            <app-button variant="primary" (click)="goBack()">Done</app-button>
        </div>
    </div>
</div>
